import { useQuery } from "@tanstack/react-query";

import { ITriggersTableContent } from "../../@types/Alerts";
import { alertsService } from "../../services/alertsService";
import { getLongFormattedDate } from "../../utils/dateFormatter";

export function getTriggersData(id: number) {
  const { data, isFetching, isError, refetch, isRefetching } = useQuery<
    ITriggersTableContent[]
  >({
    queryKey: [`triggers-table-${id}`, id],
    queryFn: async () => {
      if (!id) return [] as ITriggersTableContent[];

      const { data } = await alertsService.getTriggersByPatientId(id);

      return (data?.result ?? []) as ITriggersTableContent[];
    },
  });

  return {
    triggersTableData: data
      ? data?.map((triggerData) => {
          return {
            ...triggerData,
            created: getLongFormattedDate(triggerData.created),
          } as ITriggersTableContent;
        })
      : null,
    isFetching,
    isError,
    refetch,
    isRefetching,
  };
}
